var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledleftchevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.676 5.29289C16.0665 5.68342 16.0665 6.31658 15.676 6.70711L10.3831 12L15.676 17.2929C16.0665 17.6834 16.0665 18.3166 15.676 18.7071C15.2855 19.0976 14.6523 19.0976 14.2618 18.7071L8.36783 12.8132C7.91873 12.3641 7.91872 11.6359 8.36783 11.1868L14.2618 5.29289C14.6523 4.90237 15.2855 4.90237 15.676 5.29289Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledleftchevron);
export default __webpack_public_path__ + "static/media/disabledleftchevron.a86df40be93ad125b624bcf638e3b835.svg";
export { ForwardRef as ReactComponent };